import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"

const BlogsList = (props) => {
 
    const [topLevel, setTopLevel] = useState([])
    const [blogs, setBlogs] = useState([])

    useEffect(() => {
      apiGet(`intranetblogs/getallblog/`).then(res => {
        res.json().then(data => {
            setTopLevel(data.results)
            setBlogs(data.results)
        })
        })
    }, [])

    const deleteBlog = (e) => {

      apiDelete(`intranetblogs/deleteblog`, {id: e.target.value})
    .then(response => {if(response.ok){}
    })
  }

    const updateBlog = (e) => {
        props.setUpdateOrCreate("u")
        props.setId(e.target.value)
    }

    const createBlog = () => {
      props.setUpdateOrCreate("c")
  }

    return (
        <>
          <Container>
            <Row>
              <Col>
                <h1>Blogs</h1>
                <Form>
                  <Form.Group controlId="exampleForm.ControlSelect1">
                    <Form.Label>Example select</Form.Label>
                    <Form.Control  as="select">
                      <option value="top">All Blogs</option>
                      {topLevel.map(blog => {return (
                        <option value={blog.slug}>{blog.title}</option>
                      )})}
                    </Form.Control>
                  </Form.Group>
                    <a href={`https://business-butler-intranet.herokuapp.com/`} className="btn btn-primary">
                      Home Page
                    </a>
                    <Button onClick={(event) => createBlog(event)} className="btn btn-primary">
                      Create New
                    </Button>
                </Form>
              </Col>
            </Row>
                <div className="section">
                  {blogs.map(blog => {
                    return (
                        <Row style={{paddingBottom:"10px"}}>
                            <Col md={4}>{blog.id}</Col>
                            <Col md={4}>{blog.title}</Col>
                            <Col md={4}>
                              <Button onClick={(event) => updateBlog(event)} value={blog.id} className="btn btn-primary">
                                Edit
                              </Button>
                              <Button onClick={(event) => deleteBlog(event)} value={blog.id} className="btn btn-primary">
                                Delete
                              </Button>
                            </Col>
                        </Row>
                      
                      
                    )
                  })}
                </div>
            
            </Container>
        </>
      );

}

export default BlogsList;